import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-organisation-config.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-organisation-config.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { CRUDOperation } from "../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../../shared/models/alert";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as editOrganisationFormConstants from "../../../shared/components/recipient-select/recipient-select.constants";
import * as RecipientFormConstants from "../../../shared/components/recipient-select/recipient-select.constants";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { OrganisationSettingsService } from "../../organisations/organisation-settings.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import { phoneNumberValidator } from "../../../shared/classes/phone-number-validator";
import { OrganisationDetailsConstants, ValidationMessage } from "../shared/organisation-details-form.constants";
import { AppConfig } from "../../../app.config";
import { FileUtils } from "../../../shared/utils/file-utils";
import { AutoUnsub } from "../../../shared/decorators/autounsub.decorator";
import { LookupConstants } from "../../../shared/constants/lookup.constants";
import { FileUploadService } from "../../../shared/services/file-upload/file-upload.service";
import { ApiOrganisationConstants } from "../../../shared/constants/api-constants/api-organisation.constants";
let EditOrganisationConfigComponent = class EditOrganisationConfigComponent {
    activeModal;
    changeDetectorRef;
    userInformationService;
    fileUploadService;
    organisationService;
    appController;
    modalTitle;
    orgId;
    existingAvailableOrganisations;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    editOrganisationForm;
    selectedOrganisationName = "";
    updateLabel = SharedConstants.UPDATE_LABEL;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    bankingDetailsHeaderPlaceHolder = OrganisationDetailsConstants.BANKING_DETAILS_HEADER_PLACEHOLDER;
    streetAddressHeaderPlaceHolder = OrganisationDetailsConstants.STREET_ADDRESS_HEADER_PLACEHOLDER;
    postalAddressHeaderPlaceHolder = OrganisationDetailsConstants.POSTAL_ADDRESS_HEADER_PLACEHOLDER;
    contactPersonTextPlaceHolder = OrganisationDetailsConstants.CONTACT_PERSON_TEXT_PLACEHOLDER;
    contactNumberTextPlaceHolder = OrganisationDetailsConstants.CONTACT_NUMBER_TEXT_PLACEHOLDER;
    alternativeNumberTextPlaceHolder = OrganisationDetailsConstants.ALTERNATIVE_NUMBER_TEXT_PLACEHOLDER;
    vatReferencePlaceHolder = OrganisationDetailsConstants.VAT_REFERENCE_TEXT_PLACEHOLDER;
    bankingDetailsTextPlaceHolder1 = OrganisationDetailsConstants.BANKING_DETAILS_1_TEXT_PLACEHOLDER;
    bankingDetailsTextPlaceHolder2 = OrganisationDetailsConstants.BANKING_DETAILS_2_TEXT_PLACEHOLDER;
    bankingDetailsTextPlaceHolder3 = OrganisationDetailsConstants.BANKING_DETAILS_3_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = OrganisationDetailsConstants.STREET_ADDRESS_TEXT_PLACEHOLDER;
    suburbTextPlaceHolder = OrganisationDetailsConstants.SUBURB_TEXT_PLACEHOLDER;
    cityTextPlaceHolder = OrganisationDetailsConstants.CITY_TEXT_PLACEHOLDER;
    provinceTextPlaceHolder = OrganisationDetailsConstants.PROVINCE_TEXT_PLACEHOLDER;
    codeTextPlaceHolder = OrganisationDetailsConstants.CODE_TEXT_PLACEHOLDER;
    postalATextPlaceHolder = OrganisationDetailsConstants.POSTAL_ADDRESS_TEXT_PLACEHOLDER;
    nameTextPlaceHolder = OrganisationDetailsConstants.NAME_TEXT_PLACEHOLDER;
    defaultExtentPlaceHolder = OrganisationDetailsConstants.DEFAULT_EXTENT_TEXT_PLACEHOLDER;
    name = OrganisationDetailsConstants.ORGANISATION_NAME_FORM_CONTROL;
    contactPerson = OrganisationDetailsConstants.CONTACT_PERSON_FORM_CONTROL;
    contactNumber = OrganisationDetailsConstants.CONTACT_NUMBER_FORM_CONTROL;
    alternativeNumber = OrganisationDetailsConstants.ALTERNATIVE_NUMBER_FORM_CONTROL;
    vatReference = OrganisationDetailsConstants.VAT_REFERENCE_FORM_CONTROL;
    bankingDetails1 = OrganisationDetailsConstants.BANKING_DETAILS_1_FORM_CONTROL;
    bankingDetails2 = OrganisationDetailsConstants.BANKING_DETAILS_2_FORM_CONTROL;
    bankingDetails3 = OrganisationDetailsConstants.BANKING_DETAILS_3_FORM_CONTROL;
    streetAddress = OrganisationDetailsConstants.ADDRESS_FORM_CONTROL;
    streetSuburb = OrganisationDetailsConstants.SUBURB_FORM_CONTROL;
    streetCity = OrganisationDetailsConstants.CITY_FORM_CONTROL;
    streetProvince = OrganisationDetailsConstants.PROVINCE_FORM_CONTROL;
    streetCode = OrganisationDetailsConstants.CODE_FORM_CONTROL;
    postalAddress = OrganisationDetailsConstants.POSTAL_ADDRESS_FORM_CONTROL;
    postalSuburb = OrganisationDetailsConstants.POSTAL_SUBURB_FORM_CONTROL;
    postalCity = OrganisationDetailsConstants.POSTAL_CITY_FORM_CONTROL;
    postalProvince = OrganisationDetailsConstants.POSTAL_PROVINCE_FORM_CONTROL;
    postalCode = OrganisationDetailsConstants.POSTAL_CODE_FORM_CONTROL;
    defaultExtent = OrganisationDetailsConstants.DEFAULT_EXTENT_FORM_CONTROL;
    validationErrMsg = SharedConstants.FORM_NOT_VALID;
    validationMessage = ValidationMessage;
    postalFormControls = [this.postalAddress, this.postalSuburb, this.postalCity, this.postalProvince, this.postalCode];
    disablePostalAddressFields = RecipientFormConstants.ControlStatus;
    sameAsStreetAddressText = RecipientFormConstants.SAME_AS_STREET_PLACEHOLDER;
    organisationUpdatedMessage = OrganisationDetailsConstants.ORGANISATION_UPDATED_MSG;
    provinceOptions = LookupConstants.PROVINCE;
    sameAsResidentialChecked = false;
    bankingDetailsEnabled = true;
    authenticatedUser;
    selectedOrganisation;
    maxFileSize = AppConfig.settings.uploadFile.maximumSize;
    allowedFiles = ["PNG", "JPE", "JPEG", "JPF", "JPG", "GIF"];
    organizationLogo = OrganisationDetailsConstants.ORGANIZATION_LOGO_FORM_CONTROL;
    objectName = OrganisationDetailsConstants.OBJECT_NAME;
    organisationRole = "Super Admin"; // The organisation role that can edit banking details
    formData;
    invalidDefaultExent = OrganisationDetailsConstants.INVALID_DEFAULT_EXTENT;
    getDownloadLogoSubscription;
    updateOrganisationSubscription;
    authenticatedUserSubscription;
    getOrganisationDetailsSubscription;
    uploadOrganizationLogoSubscription;
    constructor(activeModal, changeDetectorRef, userInformationService, fileUploadService, organisationService, appController) {
        this.activeModal = activeModal;
        this.changeDetectorRef = changeDetectorRef;
        this.userInformationService = userInformationService;
        this.fileUploadService = fileUploadService;
        this.organisationService = organisationService;
        this.appController = appController;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.getUserDetails();
        this.editOrganisationForm = new FormGroup({
            name: new FormControl(null, Validators.required),
            contactPerson: new FormControl(null, Validators.required),
            contactNumber: new FormControl(null, [Validators.required, phoneNumberValidator]),
            alternativeNumber: new FormControl(null, phoneNumberValidator),
            vatReference: new FormControl(null, Validators.required),
            bankingDetails1: new FormControl(null, Validators.required),
            bankingDetails2: new FormControl(null, Validators.required),
            bankingDetails3: new FormControl(null, Validators.required),
            streetAddress: new FormControl(null, Validators.required),
            streetSuburb: new FormControl(null, Validators.required),
            streetCity: new FormControl(null, Validators.required),
            streetProvince: new FormControl(null, Validators.required),
            streetCode: new FormControl(null, [Validators.pattern(RegExp(/[0-9]{4}$/)), Validators.required]),
            postalAddress: new FormControl(null, Validators.required),
            postalSuburb: new FormControl(null, Validators.required),
            postalCity: new FormControl(null, Validators.required),
            postalProvince: new FormControl(null, Validators.required),
            postalCode: new FormControl(null, [Validators.pattern(RegExp(/[0-9]{4}$/)), Validators.required]),
            defaultExtent: new FormControl(null, [])
        });
        this.getOrganisation();
    }
    SaveOrganisation() {
        if (this.editOrganisationForm.valid) {
            const organisationData = {
                name: this.editOrganisationForm.get(this.name).value,
                contactPerson: this.editOrganisationForm.get(this.contactPerson).value,
                contactNumber: this.editOrganisationForm.get(this.contactNumber).value,
                alternativeNumber: this.editOrganisationForm.get(this.alternativeNumber).value,
                vatReference: this.editOrganisationForm.get(this.vatReference).value,
                bankingDetails1: this.editOrganisationForm.get(this.bankingDetails1).value,
                bankingDetails2: this.editOrganisationForm.get(this.bankingDetails2).value,
                bankingDetails3: this.editOrganisationForm.get(this.bankingDetails3).value,
                streetAddress: this.editOrganisationForm.get(this.streetAddress).value,
                streetSuburb: this.editOrganisationForm.get(this.streetSuburb).value,
                streetCity: this.editOrganisationForm.get(this.streetCity).value,
                streetProvince: this.editOrganisationForm.get(this.streetProvince).value,
                streetCode: this.editOrganisationForm.get(this.streetCode).value,
                postalAddress: this.editOrganisationForm.get(this.postalAddress).value,
                postalSuburb: this.editOrganisationForm.get(this.postalSuburb).value,
                postalCity: this.editOrganisationForm.get(this.postalCity).value,
                postalProvince: this.editOrganisationForm.get(this.postalProvince).value,
                postalCode: this.editOrganisationForm.get(this.postalCode).value,
                defaultExtent: this.editOrganisationForm.get(this.defaultExtent).value
            };
            this.patchData(organisationData);
        }
        else {
            this.appController.showMessage(this.validationErrMsg, AlertType.Warning);
        }
    }
    onSameAsResidentialChecked(event) {
        const checkBoxStatus = event.target.checked;
        if (checkBoxStatus) {
            this.sameAsResidentialChecked = true;
            this.disableOrEnableControls(this.postalFormControls, this.disablePostalAddressFields.disable);
        }
        else {
            this.sameAsResidentialChecked = false;
            this.disableOrEnableControls(this.postalFormControls, this.disablePostalAddressFields.enable);
        }
    }
    onResidentialInputEntered(event, formControlName) {
        if (this.sameAsResidentialChecked) {
            const input = event.target.value;
            const postalFormControl = this.editOrganisationForm.get(formControlName);
            postalFormControl.setValue(input);
        }
    }
    uploadFile(file) {
        this.formData = new FormData();
        this.formData.append("Invoice", file, file.name);
    }
    downloadLogo() {
        this.getDownloadLogoSubscription = this.organisationService.getDownloadLogo(this.selectedOrganisation.logo.id)
            .subscribe({
            next: response => {
                FileUtils.openFile(this.selectedOrganisation.logo.fileName, response);
            }, error: error => {
                this.appController.handleServerErrorMessage(this.objectName, error, CRUDOperation.Get);
            }
        });
    }
    onDeleteFile(index) {
        const fileExist = this.formData.has("file");
        if (fileExist) {
            this.formData.delete("file");
        }
    }
    loadFormData() {
        this.editOrganisationForm.get(this.name).patchValue(this.selectedOrganisation.name);
        this.editOrganisationForm.get(this.contactPerson).patchValue(this.selectedOrganisation.contactPerson);
        this.editOrganisationForm.get(this.contactNumber).patchValue(this.selectedOrganisation.contactNumber);
        this.editOrganisationForm.get(this.alternativeNumber).patchValue(this.selectedOrganisation.alternativeNumber);
        this.editOrganisationForm.get(this.vatReference).patchValue(this.selectedOrganisation.vatReference);
        this.editOrganisationForm.get(this.bankingDetails1).patchValue(this.selectedOrganisation.bankingDetails1);
        this.editOrganisationForm.get(this.bankingDetails2).patchValue(this.selectedOrganisation.bankingDetails2);
        this.editOrganisationForm.get(this.bankingDetails3).patchValue(this.selectedOrganisation.bankingDetails3);
        this.editOrganisationForm.get(this.streetAddress).patchValue(this.selectedOrganisation.streetAddress);
        this.editOrganisationForm.get(this.streetSuburb).patchValue(this.selectedOrganisation.streetSuburb);
        this.editOrganisationForm.get(this.streetCity).patchValue(this.selectedOrganisation.streetCity);
        this.editOrganisationForm.get(this.streetProvince).patchValue(this.selectedOrganisation.streetProvince);
        this.editOrganisationForm.get(this.streetCode).patchValue(this.selectedOrganisation.streetCode);
        this.editOrganisationForm.get(this.postalAddress).patchValue(this.selectedOrganisation.postalAddress);
        this.editOrganisationForm.get(this.postalSuburb).patchValue(this.selectedOrganisation.postalSuburb);
        this.editOrganisationForm.get(this.postalCity).patchValue(this.selectedOrganisation.postalCity);
        this.editOrganisationForm.get(this.postalProvince).patchValue(this.selectedOrganisation.postalProvince);
        this.editOrganisationForm.get(this.postalCode).patchValue(this.selectedOrganisation.postalCode);
        this.editOrganisationForm.get(this.defaultExtent).patchValue(this.selectedOrganisation.defaultExtent);
        this.disableBankingDetails();
        this.checkSameAsCheckBox();
        this.checkAuthUserStatus();
        this.editOrganisationForm.updateValueAndValidity();
        this.changeDetectorRef.detectChanges();
    }
    patchData(organisationData) {
        if (organisationData.defaultExtent !== undefined && organisationData.defaultExtent !== null && organisationData.defaultExtent !== "") {
            try {
                JSON.parse(organisationData.defaultExtent);
            }
            catch (e) {
                this.appController.showMessage(this.invalidDefaultExent, AlertType.Error);
                return;
            }
        }
        this.updateOrganisationSubscription = this.organisationService.updateOrganisation(this.selectedOrganisation.id, organisationData).subscribe(() => {
            if (!this.formData) {
                this.appController.showMessage(this.organisationUpdatedMessage, AlertType.Success);
                this.activeModal.close(true);
            }
            if (this.formData)
                this.uploadOrganizationLogo(this.selectedOrganisation.id);
        }, (error) => {
            this.appController.handleServerErrorMessage(this.objectName, error, CRUDOperation.Update);
        });
    }
    getUserDetails() {
        this.authenticatedUserSubscription = this.userInformationService.$authenticatedUser.subscribe(authenticatedUser => {
            this.authenticatedUser = authenticatedUser;
        });
        return this.authenticatedUser;
    }
    getOrganisation() {
        this.getOrganisationDetailsSubscription = this.organisationService.getOrganisationDetails(this.orgId).subscribe((response) => {
            this.selectedOrganisation = response;
            this.selectedOrganisationName = this.selectedOrganisation.name;
            this.loadFormData();
        }, (error) => {
            this.appController.handleServerErrorMessage(this.objectName, error, CRUDOperation.Get);
        });
    }
    disableOrEnableControls(controls, status) {
        Object.keys(this.editOrganisationForm.controls).forEach(key => {
            if (controls.indexOf(key) >= 0) {
                switch (status) {
                    case editOrganisationFormConstants.ControlStatus.enable:
                        this.enablePostalFields(key);
                        break;
                    case editOrganisationFormConstants.ControlStatus.disable:
                        this.disablePostalFields(key);
                        break;
                }
            }
        });
    }
    enablePostalFields(key) {
        this.editOrganisationForm.controls[key].enable();
        this.editOrganisationForm.controls[key].reset();
        if (key === this.postalCode) {
            this.editOrganisationForm.controls[key].setValidators([Validators.pattern(RegExp(/[0-9]{4}$/)), Validators.required]);
            this.copyStreetAddressData();
            this.editOrganisationForm.updateValueAndValidity();
            return;
        }
        this.editOrganisationForm.controls[key].setValidators(Validators.required);
        this.copyStreetAddressData();
        this.editOrganisationForm.updateValueAndValidity();
    }
    disablePostalFields(key) {
        this.editOrganisationForm.controls[key].clearValidators();
        this.editOrganisationForm.controls[key].reset();
        this.copyStreetAddressData();
        this.editOrganisationForm.controls[key].disable();
        this.editOrganisationForm.updateValueAndValidity();
    }
    copyStreetAddressData() {
        this.editOrganisationForm.get(this.postalAddress).setValue(this.editOrganisationForm.get(this.streetAddress).value);
        this.editOrganisationForm.get(this.postalSuburb).setValue(this.editOrganisationForm.get(this.streetSuburb).value);
        this.editOrganisationForm.get(this.postalCity).setValue(this.editOrganisationForm.get(this.streetCity).value);
        this.editOrganisationForm.get(this.postalProvince).setValue(this.editOrganisationForm.get(this.streetProvince).value);
        this.editOrganisationForm.get(this.postalCode).setValue(this.editOrganisationForm.get(this.streetCode).value);
    }
    checkSameAsCheckBox() {
        // checks if postal address is the same as residential address the,
        // check same as street address checkbox
        if (this.editOrganisationForm.get(this.postalAddress).value === this.editOrganisationForm.get(this.streetAddress).value && this.editOrganisationForm.get(this.postalSuburb).value === this.editOrganisationForm.get(this.streetSuburb).value && this.editOrganisationForm.get(this.postalCity).value === this.editOrganisationForm.get(this.streetCity).value && this.editOrganisationForm.get(this.postalProvince).value === this.editOrganisationForm.get(this.streetProvince).value && this.editOrganisationForm.get(this.postalCode).value === this.editOrganisationForm.get(this.streetCode).value) {
            this.sameAsResidentialChecked = true;
            this.disableOrEnableControls(this.postalFormControls, this.disablePostalAddressFields.disable);
            this.changeDetectorRef.detectChanges();
        }
    }
    checkAuthUserStatus() {
        const authUserInfo = this.authenticatedUser;
        let authUserRoles;
        authUserInfo.organisations.forEach(organisation => {
            if (organisation.id === this.selectedOrganisation.id) {
                authUserRoles = organisation.userSystemRoles;
            }
        });
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < authUserRoles.length; i++) {
            if (authUserRoles[i].role === this.organisationRole || authUserInfo.isSysAdmin) {
                this.enableBankingDetails();
                break;
            }
        }
    }
    enableBankingDetails() {
        this.editOrganisationForm.get(this.bankingDetails1).enable();
        this.editOrganisationForm.get(this.bankingDetails1).setValidators(Validators.required);
        this.editOrganisationForm.get(this.bankingDetails2).enable();
        this.editOrganisationForm.get(this.bankingDetails2).setValidators(Validators.required);
        this.editOrganisationForm.get(this.bankingDetails3).enable();
        this.editOrganisationForm.get(this.bankingDetails3).setValidators(Validators.required);
        this.editOrganisationForm.get(this.vatReference).enable();
        this.editOrganisationForm.get(this.vatReference).setValidators(Validators.required);
        this.bankingDetailsEnabled = true;
    }
    disableBankingDetails() {
        this.editOrganisationForm.get(this.bankingDetails1).disable();
        this.editOrganisationForm.get(this.bankingDetails1).clearValidators();
        this.editOrganisationForm.get(this.bankingDetails2).disable();
        this.editOrganisationForm.get(this.bankingDetails2).clearValidators();
        this.editOrganisationForm.get(this.bankingDetails3).disable();
        this.editOrganisationForm.get(this.bankingDetails3).clearValidators();
        this.editOrganisationForm.get(this.vatReference).disable();
        this.editOrganisationForm.get(this.vatReference).clearValidators();
        this.bankingDetailsEnabled = false;
    }
    uploadOrganizationLogo(organizationId) {
        const url = `${ApiOrganisationConstants.URL}/${organizationId}/${ApiOrganisationConstants.FUNCTION_UPLOAD_LOGO}`;
        this.fileUploadService.uploadFile(url, this.formData, "Municipal", "default", null, false, (result) => {
            if (result !== null) {
                this.appController.showMessage(this.organisationUpdatedMessage, AlertType.Success);
                this.activeModal.close(true);
            }
        });
    }
    onBtnUpdateClicked() {
        this.SaveOrganisation();
    }
    onBtnCancelClicked() {
        this.activeModal.close();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: ChangeDetectorRef },
        { type: UserInformationService },
        { type: FileUploadService },
        { type: OrganisationSettingsService },
        { type: AppControllerService }
    ];
    static propDecorators = {
        modalTitle: [{ type: Input }],
        orgId: [{ type: Input }],
        existingAvailableOrganisations: [{ type: Input }]
    };
};
EditOrganisationConfigComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-edit-organisation-config",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], EditOrganisationConfigComponent);
export { EditOrganisationConfigComponent };
